import React from 'react';
import AttachmentProvider from './attachment-provider';

export default function withAttachment(WrappedComponent) {
  return function AttachmentProviderHOC(props) {
    return (
      <AttachmentProvider>
        <WrappedComponent {...props} />
      </AttachmentProvider>
    );
  };
};
